import React, { Suspense, lazy } from 'react';
import { BabyHeader } from './components/BabyHeader';
import { BabyProductHero } from './components/BabyProductHero';
import { MobileImageCarousel } from './components/MobileImageCarousel';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { HiddenProblemSection } from './components/HiddenProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { EmotionalHeroSection } from './components/EmotionalHeroSection';
import { BabyBenefitsSection } from './components/BabyBenefitsSection';
import { WhatYouTriedSection } from './components/WhatYouTriedSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { LocalIngredientsSection } from './components/LocalIngredientsSection';
import { TextureGuideSection } from './components/TextureGuideSection';
import { BackingSection } from './components/BackingSection';
import { LifestyleEaseSection } from './components/LifestyleEaseSection';
import { BabyTestimonials } from './components/BabyTestimonials';
import { ForWhoSection } from './components/ForWhoSection';
import { BabyHowToUse } from './components/BabyHowToUse';
import { BabyFormatSection } from './components/BabyFormatSection';
import { PricingSection } from './components/PricingSection';
import { BabyCTASection } from './components/BabyCTASection';
import { BabyFAQ } from './components/BabyFAQ';
import { Footer } from './components/Footer';
// Simple loading fallback component
const LoadingFallback = () => <div className="py-8" data-id="element-0" />;
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-1">
      <BabyHeader data-id="element-2" />
      <main data-id="element-3">
        <BabyProductHero data-id="element-4" />
        <MobileImageCarousel data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <BeforeAfterSection data-id="element-7" />
        <HiddenProblemSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <EmotionalHeroSection data-id="element-10" />
        <BabyBenefitsSection data-id="element-11" />
        <WhatYouTriedSection data-id="element-12" />
        <WhatsInsideSection data-id="element-13" />
        <LocalIngredientsSection data-id="element-14" />
        <TextureGuideSection data-id="element-15" />
        <BackingSection data-id="element-16" />
        <LifestyleEaseSection data-id="element-17" />
        <BabyTestimonials data-id="element-18" />
        <ForWhoSection data-id="element-19" />
        <BabyHowToUse data-id="element-20" />
        <BabyFormatSection data-id="element-21" />
        <PricingSection data-id="element-22" />
        <BabyCTASection data-id="element-23" />
        <BabyFAQ data-id="element-24" />
      </main>
      <Footer data-id="element-25" />
    </div>;
}